/**
 * API Service - Backward Compatibility Layer
 * 
 * This file maintains backward compatibility with the old API structure.
 * For new code, import services directly:
 * 
 *   OLD (deprecated):
 *   import { assetService } from 'services/api';
 * 
 *   NEW (preferred):
 *   import { assetService } from 'services';
 *   // or
 *   import assetService from 'services/assetService';
 */

import userServiceDefault from "./userService";

export { assetCategoryService } from "./assetCategoryService";
export { assetService } from "./assetService";
export { departmentService } from "./departmentService";
export { roomService } from "./roomService";
export { handoverService } from "./handoverService";
export { dropdownService } from "./dropdownService";
export { configurationService } from "./configurationService";
export { productionLineService } from "./productionLineService";
export { productionManagerService } from "./productionManagerService";
export { productionOrderService } from "./productionOrderService";
export { productionStepService } from "./productionStepService";
export { workerEquipmentService } from "./workerEquipmentService";
export { equipmentUsageService } from "./equipmentUsageService";
export { workerCalendarService } from "./workerCalendarService";

// Phase 8: Training Mode Services
export { courseService } from "./courseService";
export { classService } from "./classService";
export { studentEquipmentAssignmentService } from "./studentEquipmentAssignmentService";
export { assetCourseMappingService } from "./assetCourseMappingService";

// Phase 9: Maintenance Management Services
export { maintenanceScheduleService } from "./maintenanceScheduleService";
export { maintenanceRecordService } from "./maintenanceRecordService";
export { dashboardService } from "./dashboardService";

// Phase 11: Practice Session Services
export { practiceSessionService, practiceErrorLogService, sessionEvaluationService } from "./practiceSessionService";

// Phase 14: Asset Lifecycle State Machine
export { assetLifecycleService } from "./assetLifecycleService";

// Phase 13: Work Session (Production Worker Flow)
export { workSessionService } from "./workSessionService";

export const userService = userServiceDefault;
